import React, { useState } from 'react';
import { colors, radius, fonts } from '../theme';

interface GalleryImage {
  src: string;
  title: string;
  category: string;
}

const galleryImages: GalleryImage[] = [
  { src: 'gallery_1.jpg', title: 'Ambiance Le Siam', category: 'restaurant' },
  { src: 'gallery_2.jpg', title: 'Saveurs thaïlandaises', category: 'cuisine' },
  { src: 'gallery_3.jpg', title: 'Caraïbes & Thaï', category: 'cuisine' },
  { src: 'gallery_4.jpg', title: 'Dégustation', category: 'restaurant' },
  { src: 'gallery_5.jpg', title: 'Le Siam', category: 'restaurant' },
  { src: 'gallery_int.jpg', title: 'Intérieur du restaurant', category: 'restaurant' },
  { src: 'gallery_terrace.jpg', title: 'Terrasse plage', category: 'restaurant' },
  { src: 'gallery_bar.jpg', title: 'Bar lounge', category: 'bar' },
  { src: 'gallery_kitchen.jpg', title: 'En cuisine', category: 'cuisine' },
  { src: 'gallery_sunset.jpg', title: 'Dîner au coucher', category: 'restaurant' },
];

const categories = ['all', 'restaurant', 'cuisine', 'bar'];

export function GalleryPage() {
  const [filter, setFilter] = useState('all');
  const [lightbox, setLightbox] = useState<GalleryImage | null>(null);

  const filtered = filter === 'all' ? galleryImages : galleryImages.filter(i => i.category === filter);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>
        <h1 style={{ fontSize: 28, fontWeight: 700, color: colors.gold, margin: 0 }}>📸 Galerie</h1>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {categories.map(c => (
            <button
              key={c}
              onClick={() => setFilter(c)}
              style={{
                padding: '6px 16px', borderRadius: 20, border: 'none', cursor: 'pointer',
                background: filter === c ? colors.gold : 'rgba(201,169,110,0.15)',
                color: filter === c ? '#0F0F23' : colors.gold,
                fontWeight: filter === c ? 700 : 400, fontSize: 13,
                fontFamily: fonts.body, transition: 'all 0.2s',
              }}
            >
              {c === 'all' ? 'Tout' : c === 'restaurant' ? '🍽️ Restaurant' : c === 'cuisine' ? '🍜 Cuisine' : '🍹 Bar'}
            </button>
          ))}
        </div>
      </div>

      {/* Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 16 }}>
        {filtered.map((img, idx) => (
          <div
            key={idx}
            onClick={() => setLightbox(img)}
            style={{
              position: 'relative', borderRadius: radius.md, overflow: 'hidden',
              cursor: 'pointer', aspectRatio: '1', background: '#1A1A3A',
              transition: 'transform 0.2s, box-shadow 0.2s',
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 12px 32px rgba(201,169,110,0.3)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none'; }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/${img.src}`}
              alt={img.title}
              loading="lazy"
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            />
            <div style={{
              position: 'absolute', bottom: 0, left: 0, right: 0,
              background: 'linear-gradient(transparent, rgba(15,15,35,0.9))',
              padding: '40px 16px 12px', color: '#F5F5F5', fontSize: 14, fontWeight: 600,
            }}>
              {img.title}
            </div>
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          onClick={() => setLightbox(null)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.92)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999, cursor: 'pointer', padding: 24,
          }}
        >
          <div style={{ position: 'relative', maxWidth: '90vw', maxHeight: '90vh' }} onClick={e => e.stopPropagation()}>
            <img
              src={`${process.env.PUBLIC_URL}/${lightbox.src}`}
              alt={lightbox.title}
              style={{ maxWidth: '90vw', maxHeight: '85vh', borderRadius: radius.md, objectFit: 'contain', display: 'block' }}
            />
            <div style={{ textAlign: 'center', color: colors.gold, marginTop: 12, fontSize: 16, fontWeight: 600 }}>
              {lightbox.title}
            </div>
            <button
              onClick={() => setLightbox(null)}
              style={{
                position: 'absolute', top: -16, right: -16, width: 36, height: 36,
                borderRadius: '50%', border: 'none', background: colors.gold, color: '#0F0F23',
                fontSize: 20, fontWeight: 700, cursor: 'pointer', lineHeight: '36px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}
            >×</button>
          </div>
        </div>
      )}
    </div>
  );
}